import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import PointsCard from '../PointsCard'

import { setAccountStatus } from '../../../../modules/profile/actions/creators'

import { setLoyaltyPoints } from '../../../../modules/loyalty/actions/creators'

const mapStateToProps = reduxState => {
  const { auth, profile, loyalty } = reduxState

  const { accessToken } = auth

  const { primaryInfo, advanceAccount, registrationToken } = profile

  const { loyaltyPoints } = loyalty

  return {
    accessToken,
    primaryInfo,
    advanceAccount,
    registrationToken,
    loyaltyPoints,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setAccountStatus,
      setLoyaltyPoints,
      push,
    },
    dispatch,
  )

const ConnectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PointsCard)

export default ConnectedComponent
